/**
 * Settings API Endpoints
 * Framework-agnostic endpoint definitions for settings modules
 */

/**
 * FAQ API Endpoints
 */
export const FAQ_ENDPOINTS = {
  LIST: "app-content/get-faq",
  CREATE: "app-content/create-faq",
  UPDATE: "app-content/update-faq",
  TOGGLE_STATUS: "app-content/toggle-faq-status",
} as const;

/**
 * Privacy Policy API Endpoints
 */
export const PRIVACY_POLICY_ENDPOINTS = {
  GET: "app-content/get-privacy-policy",
  UPDATE: "app-content/update-privacy-policy",
} as const;

/**
 * Terms & Conditions API Endpoints
 */
export const TERMS_CONDITION_ENDPOINTS = {
  GET: "app-content/get-terms-condition",
  UPDATE: "app-content/update-terms-condition",
} as const;

/**
 * Combined Settings Endpoints
 */
export const SETTINGS_ENDPOINTS = {
  faq: FAQ_ENDPOINTS,
  privacyPolicy: PRIVACY_POLICY_ENDPOINTS,
  termsCondition: TERMS_CONDITION_ENDPOINTS,
} as const;
